import React from 'react';
import { Icon } from '@chakra-ui/react';

export const SvgSortIcon = (props) => {
  return (
    <Icon viewBox="0 0 18 18" color="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M7.99 6.01a1 1 0 0 0-1.707-.71L5 6.586V1a1 1 0 1 0-2 0v5.586L1.717 5.3A1 1 0 1 0 .3 6.717L3.293 9.7a1 1 0 0 0 1.414 0L7.7 6.717a1 1 0 0 0 .29-.707z"
      />
    </Icon>
  );
};
